import { ConnectedCommandsTable } from 'features/manual-command/table';

export function ChargePointsCommandsPage() {
  return <ConnectedCommandsTable />;
}
